import { clientAPI } from '../configs/configs'

const urlBase =  '/returns'
export default class Carriers {

  static async loadCarriersReverse(filters) {
    return new Promise((res, rej) => {
        clientAPI
            .post(`${urlBase}/carriers/b2c-reverse`, filters)
            .then((response) => {
                res(response.data)
            })
            .catch((error) => {
                rej(error)
            }) 
    })
  }
  static async loadCarriersAgencies(filters) {
    return new Promise((res, rej) => {
        clientAPI
            .get(`${urlBase}/carriers/b2c-reverse/agencies/${filters.carrier}`)
            .then((response) => {
                res(response.data)
            })
            .catch((error) => {
                rej(error)
            }) 
    })
  }
  static async loadGeoCoordinates(filters) {
    return new Promise((res, rej) => {
        clientAPI
            .get(`${urlBase}/carriers/coordinates/${filters.cep}`)
            .then((response) => {
                res(response.data)
            })
            .catch((error) => {
                rej(error)
            }) 
    })
  }
}
